import React from 'react';
import { Icon } from '@noths/polaris-design-system-core-components';
import { useRouter } from 'next/router';

import * as styles from 'src/components/molecules/TaxonomyNav/BackToParentLevelLink.styles';

export interface BackToParentLevelLinkProps {
  /** The name of the level the link points at, announced via the aria-label. */
  destinationName: string;
  href: string;
  /** The visible link text. */
  label: string;
}

export const BackToParentLevelLink = ({
  destinationName,
  href,
  label,
}: BackToParentLevelLinkProps) => {
  const router = useRouter();

  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    router.push(href, undefined, { shallow: true, scroll: false });
  };

  return (
    <a
      aria-label={`Back to ${destinationName}`}
      css={styles.link}
      data-testid="taxonomy-nav-back-to-parent"
      href={href}
      onClick={onClick}
    >
      <Icon name="levelBackUp" size="sm" />
      {label}
    </a>
  );
};
